import { createFileRoute, Navigate, useSearch } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

export const Route = createFileRoute("/_auth/reset-password")({
	component: RouteComponent,
	validateSearch: zodValidator(
		z.object({
			recovery_token: z.string(),
		}),
	),
});

function RouteComponent() {
	const { recovery_token } = useSearch({ from: Route.id });

	return <Navigate to="/redefinir-senha" search={{ recovery_token }} />;
}
